/*
  REEF - Build Your Bundle landing page behaviour.
  Loaded ONLY by sections/reef-bundle-landing.liquid, so it never runs on any other page.

  - collection tabs: loads a collection's products in-page (Section Rendering API)
  - empty tabs: a tab that loads to an empty grid removes itself (see showCollection)
  - quick add: button under each card, adds without opening the drawer
  - quick view: popup with images, description, price, add to basket
  - active tier: bold outline, hero headline + second line, and step 1 / step 3 wording all follow
    the ELIGIBLE basket quantity

  ACTIVE TIER SOURCE OF TRUTH: /cart.js, counted against the promo bar's exclude list. An earlier
  version watched data-reef-pb-qty on a promo bar element, but the first [data-reef-pb] in the DOM
  is the copy inside the cart drawer, and that node is replaced on every add - so the watcher died
  after the first quick add. The attribute is still observed, but document-wide and only as a backup.
*/
(function () {
  'use strict';
  var root = document.querySelector('[data-byb-root]');
  if (!root || root.__bybReady) return;
  root.__bybReady = true;

  var ROUTE = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-byb-tile]'));
  var panel = root.querySelector('[data-byb-panel]');
  var grid = root.querySelector('[data-byb-grid]');
  var titleEl = root.querySelector('[data-byb-panel-title]');
  var countEl = root.querySelector('[data-byb-panel-count]');
  var noun = root.getAttribute('data-count-noun') || 'perfumes';
  var cache = {};
  var current = null;
  var modal = null;
  var lastFocus = null;

  function excludedHandles() {
    try {
      var holder = document.querySelector('[data-reef-pb-config]');
      return JSON.parse(holder.textContent).exclude || [];
    } catch (e) { return []; }
  }

  // The promo bar script owns tier pricing and the progress bar. Asking it to refresh re-prices any
  // newly inserted cards and re-reads the basket.
  function refreshPromo() {
    document.dispatchEvent(new CustomEvent('reef:promo-bar:refresh'));
  }

  function fetchText(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    });
  }

  // ---------- Active tier ----------
  var tierEls = Array.prototype.slice.call(document.querySelectorAll('[data-byb-tier]'));
  var step1 = document.querySelector('[data-byb-step="1"]');
  var step3 = document.querySelector('[data-byb-step="3"]');
  var heroTitle = document.querySelector('[data-byb-hero="title"]');
  var heroAlt = document.querySelector('[data-byb-hero="alt"]');
  var step1Default = step1 ? step1.textContent : '';
  var step3Default = step3 ? step3.textContent : '';
  var heroTitleDefault = heroTitle ? heroTitle.innerHTML : '';
  var heroAltDefault = heroAlt ? heroAlt.textContent : '';
  var cartSeq = 0;

  function tierQty(el) { return parseInt(el.getAttribute('data-byb-tier'), 10) || 0; }

  // Only touch the DOM when the wording actually changes, so the hero never flickers.
  function setText(el, text) { if (el && el.textContent !== text) el.textContent = text; }
  function setHTML(el, html, key) {
    if (!el || el.getAttribute('data-byb-applied') === key) return;
    el.innerHTML = html;
    el.setAttribute('data-byb-applied', key);
  }

  function syncTiers(qty) {
    if (!tierEls.length) return;
    var lowest = null;
    var active = null;
    tierEls.forEach(function (el) {
      var q = tierQty(el);
      if (!lowest || q < tierQty(lowest)) lowest = el;
      if (qty >= q && (!active || q > tierQty(active))) active = el;
    });
    if (!active) active = lowest;
    tierEls.forEach(function (el) { el.classList.toggle('reef-byb__tier--hot', el === active); });
    setText(step1, active.getAttribute('data-step1') || step1Default);
    setText(step3, active.getAttribute('data-step3') || step3Default);
    // The headline is merchant-entered HTML from the tier block (it carries the <em> accent).
    setHTML(heroTitle, active.getAttribute('data-hero-title') || heroTitleDefault, String(tierQty(active)));
    setText(heroAlt, active.getAttribute('data-hero-alt') || heroAltDefault);
    root.setAttribute('data-byb-qty', qty);
  }

  function eligibleQty(cart) {
    var exclude = excludedHandles();
    var total = 0;
    (cart.items || []).forEach(function (line) {
      if (exclude.indexOf(line.handle) === -1) total += line.quantity;
    });
    return total;
  }

  // Sequence-guarded so a slow early response can never overwrite a newer one.
  function pullCart() {
    var seq = ++cartSeq;
    fetch(ROUTE + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { if (seq === cartSeq) syncTiers(eligibleQty(cart)); })
      .catch(function () {});
  }

  function watchBasket() {
    syncTiers(0);
    pullCart();

    // Dawn publishes this whenever the basket changes, including removals inside the drawer.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { pullCart(); });
    }
    document.addEventListener('reef:promo-bar:refresh', pullCart);

    // Backup: whenever ANY promo bar is re-rendered, re-check the basket.
    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(function () { pullCart(); }).observe(document.body, {
        attributes: true,
        subtree: true,
        attributeFilter: ['data-reef-pb-qty']
      });
    }

    // Coming back to the tab / bfcache restore.
    window.addEventListener('pageshow', pullCart);
  }

  // ---------- Collection tabs ----------
  // Liquid already leaves out tabs with nothing in stock. This catches what Liquid cannot see: a
  // collection whose only in-stock products are on the offer's exclude list. The tab is removed and
  // the first remaining tab takes over. Each call shrinks the list, so it cannot loop.
  function removeTile(tile) {
    tile.hidden = true;
    tile.classList.remove('is-active');
    tiles = tiles.filter(function (t) { return t !== tile; });
    if (tiles.length) {
      showCollection(tiles[0], false);
    } else {
      panel.hidden = true;
      panel.style.display = 'none';
    }
  }

  function showCollection(tile, scroll) {
    var handle = tile.getAttribute('data-handle');
    current = handle;
    tiles.forEach(function (t) { t.classList.toggle('is-active', t === tile); });
    titleEl.textContent = tile.getAttribute('data-title');
    countEl.textContent = '';
    grid.classList.add('is-loading');
    if (scroll) panel.scrollIntoView({ behavior: 'smooth', block: 'start' });

    if (!cache[handle]) cache[handle] = fetchText(ROUTE + 'collections/' + handle + '?section_id=reef-byb-products');

    cache[handle].then(function (html) {
      if (current !== handle) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var list = doc.querySelector('[data-byb-list]');
      if (!list) throw new Error('no list');
      var exclude = excludedHandles();
      Array.prototype.forEach.call(list.querySelectorAll('[data-byb-handle]'), function (li) {
        if (exclude.indexOf(li.getAttribute('data-byb-handle')) !== -1) li.parentNode.removeChild(li);
      });
      var n = list.querySelectorAll('[data-byb-handle]').length;
      if (n === 0) {
        removeTile(tile);
        return;
      }
      grid.innerHTML = '';
      grid.appendChild(document.importNode(list, true));
      countEl.textContent = n + ' ' + noun;
      grid.classList.remove('is-loading');
      refreshPromo();
    }).catch(function () {
      delete cache[handle];
      if (scroll) window.location.href = tile.href;
      else grid.classList.remove('is-loading');
    });
  }

  tiles.forEach(function (tile) {
    tile.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      showCollection(tile, true);
    });
  });

  // ---------- Basket (stays on the page, does not open the drawer) ----------
  function swapInner(html, fromSelector, toSelector) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var src = doc.querySelector(fromSelector);
    var dst = document.querySelector(toSelector);
    if (src && dst) dst.innerHTML = src.innerHTML;
  }

  function updateCartUI(sections) {
    if (!sections) return;
    swapInner(sections['cart-drawer'], '#CartDrawer', '#CartDrawer');
    swapInner(sections['cart-icon-bubble'], '.shopify-section', '#cart-icon-bubble');
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      drawer.classList.remove('is-empty');
      var overlay = drawer.querySelector('#CartDrawer-Overlay');
      if (overlay && typeof drawer.close === 'function') overlay.addEventListener('click', function () { drawer.close(); });
    }
  }

  // Resolves to { ok, json }. On success the drawer, basket count, promo bar and tiers are all updated.
  function addVariant(variantId) {
    return fetch(ROUTE + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    }).then(function (r) {
      return r.json().then(function (j) { return { ok: r.ok, json: j }; });
    }).then(function (res) {
      if (res.ok) {
        updateCartUI(res.json.sections);
        refreshPromo(); // also triggers pullCart via the event listener above
      }
      return res;
    });
  }

  // ---------- Quick add (button under each card) ----------
  function quickAdd(btn) {
    var label = btn.getAttribute('data-label') || btn.textContent;
    btn.setAttribute('data-label', label);
    btn.disabled = true;
    btn.textContent = 'Adding...';

    function reset(delay) {
      setTimeout(function () {
        btn.classList.remove('is-added', 'is-error');
        btn.textContent = label;
        btn.disabled = false;
      }, delay);
    }

    addVariant(btn.getAttribute('data-variant-id')).then(function (res) {
      if (res.ok) {
        btn.classList.add('is-added');
        btn.textContent = '\u2713 Added';
        reset(1500);
      } else {
        btn.classList.add('is-error');
        btn.textContent = 'Not Available';
        reset(2200);
      }
    }).catch(function () {
      btn.classList.add('is-error');
      btn.textContent = 'Try Again';
      reset(2200);
    });
  }

  // ---------- Quick view ----------
  function ensureModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'reef-byb-qv';
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML =
      '<div class="reef-byb-qv__overlay" data-qv-close></div>' +
      '<div class="reef-byb-qv__sheet" role="dialog" aria-modal="true" aria-label="Product details" tabindex="-1">' +
      '<button type="button" class="reef-byb-qv__x" data-qv-close aria-label="Close">&times;</button>' +
      '<div class="reef-byb-qv__content" data-qv-content></div></div>';
    document.body.appendChild(modal);
    modal.addEventListener('click', onModalClick);
    modal.addEventListener('submit', onSubmit);
    return modal;
  }

  function openQuickView(handle, fallbackUrl) {
    ensureModal();
    lastFocus = document.activeElement;
    var content = modal.querySelector('[data-qv-content]');
    content.innerHTML = '<div class="reef-byb-qv__loading">Loading...</div>';
    content.scrollTop = 0;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
    modal.querySelector('.reef-byb-qv__sheet').focus();

    fetchText(ROUTE + 'products/' + handle + '?section_id=reef-byb-quickview').then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var body = doc.querySelector('[data-qv-body]');
      if (!body) throw new Error('no body');
      content.innerHTML = '';
      content.appendChild(document.importNode(body, true));
      refreshPromo();
    }).catch(function () {
      window.location.href = fallbackUrl;
    });
  }

  function closeQuickView() {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !drawer.classList.contains('active')) document.body.classList.remove('overflow-hidden');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  function onModalClick(e) {
    if (e.target.closest('[data-qv-basket]')) {
      closeQuickView();
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') drawer.open();
      else window.location.href = ROUTE + 'cart';
      return;
    }
    if (e.target.closest('[data-qv-close]')) closeQuickView();
  }

  // Clicks inside the grid: the quick add button adds straight away, anything else on a card opens
  // the popup instead of the product page.
  grid.addEventListener('click', function (e) {
    if (e.metaKey || e.ctrlKey || e.shiftKey) return;
    if (e.target.closest('[data-reef-pb-info]')) return; // the offers "i" button belongs to the promo bar

    var addBtn = e.target.closest('[data-byb-add]');
    if (addBtn) {
      e.preventDefault();
      e.stopPropagation();
      if (!addBtn.disabled) quickAdd(addBtn);
      return;
    }

    var card = e.target.closest('[data-byb-handle]');
    if (!card) return;
    if (e.target.closest('button[disabled]')) return;
    var link = card.querySelector('a[href*="/products/"]');
    e.preventDefault();
    openQuickView(card.getAttribute('data-byb-handle'), link ? link.href : ROUTE + 'products/' + card.getAttribute('data-byb-handle'));
  }, true);

  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.keyCode === 27) && modal && modal.classList.contains('is-open')) closeQuickView();
  });

  function showDone() {
    var buy = modal.querySelector('[data-qv-buy]');
    var done = modal.querySelector('[data-qv-done]');
    if (buy) buy.hidden = true;
    if (done) done.hidden = false;
    var next = modal.querySelector('[data-qv-next]');
    function readPill() {
      var pill = document.querySelector('.reef-pb--header [data-reef-pb-pill-text]');
      if (pill && next) next.innerHTML = pill.innerHTML;
    }
    setTimeout(readPill, 700);
    setTimeout(readPill, 1600);
  }

  function onSubmit(e) {
    var form = e.target.closest('[data-qv-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[data-qv-add]');
    var err = form.querySelector('[data-qv-error]');
    var idField = form.querySelector('[name="id"]');
    if (!btn || btn.disabled || !idField) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';
    if (err) err.hidden = true;

    addVariant(idField.value).then(function (res) {
      if (!res.ok) {
        if (err) { err.textContent = res.json.description || res.json.message || 'Sorry, that could not be added.'; err.hidden = false; }
        btn.disabled = false;
        btn.textContent = label;
        return;
      }
      showDone();
    }).catch(function () {
      if (err) { err.textContent = 'Something went wrong. Please try again.'; err.hidden = false; }
      btn.disabled = false;
      btn.textContent = label;
    });
  }

  function start() {
    watchBasket();
    if (tiles.length) showCollection(tiles[0], false);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
